import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { useState, useEffect } from 'react'
import './App.css'
import Layout from './components/Layout'
import PowerComponent from './components/Power/Index'
import FansComponent from './components/Fans/Index'
// import TopicComponent from './components/Topic/Index'
// import IssueComponent from './components/Issue/Index'
import AccountComponent from './components/AccountComponent'
import AuthorizeComponent from './components/AuthorizeComponent'

import './styles/style.css'
import Privacy from './components/Privacy'
import Terms from './components/Terms'
import { useMediaQuery } from 'react-responsive'
import axios from 'axios'

import GroupPower from './components/GroupPower/Index'
import GroupFans from './components/GroupFans/Index'
// import GroupTopic from './components/GroupTopic/Index'
import Login from './components/Login'
import { AuthContext } from './components/AuthContext'
import Cookies from 'js-cookie'
import Satisfy from './components/Satisfy'
import Computex from './components/Computex'
import BarLoader from 'react-spinners/BarLoader'
import { ToastContainer, toast, Slide } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
function App() {
  const [isLevel2, setIsLevel2] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const BaseUrl = 'https://kolstarapi.dsigroup.com.tw/'

  // discord 通知
  async function sendDiscordNotification(message) {
    try {
      await axios.post('/api/send-notification', {
        content: message,
      })
    } catch (error) {
      console.error('Failed', error)
    }
  }

  const isMobile = useMediaQuery({ query: '(max-width: 576px)' })

  // 當前使用者
  const [currentUser, setCurrentUser] = useState({
    inc_id: '',
    tk: '',
    kol_id: '',
    kol_name: '',
    lv: 1,
    inc_name: '',
    inc_icon: '',
    isLocked: true,
  })

  const timeout = 30 * 60 * 1000

  useEffect(() => {
    Cookies.get('tk')
    if (Cookies.get('tk')) {
      const getUser = JSON.parse(Cookies.get('tk'))
      setCurrentUser(getUser)
    } else {
      setTimeout(() => {
        popUpToast('網頁已逾時，請重新登錄')
      }, timeout)
    }
  }, [])

  useEffect(() => {
    if (currentUser.lv === 2) {
      setIsLevel2(true)
    } else {
      setIsLevel2(false)
    }
  }, [currentUser])

  // BarLoader
  window.addEventListener('resize', updateSize)
  const actualInnerWidth = document.getElementById('mynav')
    ? document.getElementById('mynav').offsetWidth
    : document.body.clientWidth
  const [loadingBarLength, setLoadingBarLength] = useState(actualInnerWidth)
  function updateSize() {
    setLoadingBarLength(actualInnerWidth)
  }

  // toastify
  const toastId = 'toast-info'
  function popUpToast(msg) {
    toast.info(msg, {
      position: isMobile ? 'top-right' : 'bottom-right',
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'light',
      toastId: toastId,
    })
  }

  const brandArr = [
    {
      title: 'Facebook',
      brand: 'fb',
      color: '#4267B2',
    },
    {
      title: 'Instagram',
      brand: 'ig',
      color: '#C13584',
    },
    {
      title: 'Youtube',
      brand: 'yt',
      color: '#FF0000',
    },
  ]

  return (
    <>
      <ToastContainer
        position="bottom-right"
        autoClose={3000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Slide}
      />
      <BarLoader
        cssOverride={{
          overflow: 'hidden',
          position: 'fixed ',
          zIndex: '1021',
        }}
        color="#df0080"
        width={loadingBarLength}
        loading={isLoading}
      />

      <AuthContext.Provider
        value={{
          currentUser,
          setCurrentUser,
          isLevel2,
          BaseUrl,
          setIsLoading,
          isLoading,
          popUpToast,
          brandArr,
          sendDiscordNotification,
        }}
      >
        {/* TODO: 改 Layout 把側邊欄放進來 */}
        <BrowserRouter>
          <Routes>
            {!Cookies.get('tk') && <Route path="/" element={<Login />} />}
            {/* <Route path="/login" element={<Login />} /> */}

            <Route
              path="/"
              element={
                <Layout
                  currentUser={currentUser}
                  setCurrentUser={setCurrentUser}
                  isLevel2={isLevel2}
                />
              }
            >
              {Cookies.get('tk') && (
                <>
                  {isLevel2 || <Route index element={<PowerComponent />} />}
                  {isLevel2 && <Route index element={<GroupPower />} />}
                  {/* Lv2 && 天神帳號 */}
                  <Route path="account" element={<AccountComponent />} />
                  {isLevel2 || (
                    <Route path="fans" element={<FansComponent />} />
                  )}
                  {isLevel2 && <Route path="fans" element={<GroupFans />} />}
                  {/* {isLevel2 || (
                    <Route path="topic" element={<TopicComponent />} />
                  )}
                  {isLevel2 && <Route path="topic" element={<GroupTopic />} />} */}
                  {/* <Route path="issue" element={<IssueComponent />} /> */}
                  {isLevel2 || (
                    <Route path="authorize" element={<AuthorizeComponent />} />
                  )}
                  <Route path="satisfy" element={<Satisfy />} />
                  {/* <Route path="computex" element={<Computex />} /> */}
                </>
              )}

              <Route path="privacy" element={<Privacy />} />
              <Route path="terms" element={<Terms />} />
            </Route>
            {/* 404 就回首頁 */}
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </BrowserRouter>
      </AuthContext.Provider>
    </>
  )
}

export default App
